import { ICatAge } from "libs/cat-calculations/src/lib/cat-calculations.types";
import dayjs from "dayjs";

const NUMBER_OF_DAYS_IN_A_WEEK = 7;

export const DAYS_IN_YEAR = 365;

export const NUMBER_OF_MONTHS_IN_A_YEAR = 12;

export const toWeeks = (days: number): number => days / NUMBER_OF_DAYS_IN_A_WEEK;
export const fromWeeks = (weeks: number): number => weeks * NUMBER_OF_DAYS_IN_A_WEEK;

export const getNow = () => dayjs();

export const getCatAgeFromDate = (dateString?: string): ICatAge => {
  if (!dateString) {
    return { years: 0, months: 0 };
  }
  const now = getNow();
  const pastDate = dayjs(dateString);

  const totalMonths = now.diff(pastDate, "month");

  const years = Math.floor(totalMonths / NUMBER_OF_MONTHS_IN_A_YEAR);
  const months = totalMonths % NUMBER_OF_MONTHS_IN_A_YEAR;

  return { years, months };
};
